import { useAtom } from "jotai";

import { interventionSectionRenderIndexAtom } from "./intervention-section.state";

export const useInterventionSectionRenderIndex = () => {
  const [renderIndex, setRenderIndex] = useAtom(
    interventionSectionRenderIndexAtom
  );

  const incrementIndex = () => {
    setRenderIndex((index) => index + 1);
  };

  return {
    renderIndex,
    incrementIndex,
  };
};
